import React from 'react';

const getOrderType = (order_name) => {
  if (!order_name) return 'generic';
  const name = order_name.toLowerCase();
  if (name.includes('mesa') || name.includes('terraza')) return 'table';
  if (name.includes('barra')) return 'bar';
  if (name.includes('llevar') || name.includes('domicilio')) return 'takeaway';
  return 'named';
};

const IconTable = () => (
  <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
    <rect x="8" y="17" width="24" height="4" rx="2" fill="#F9EFD7"/>
    <rect x="10" y="21" width="3" height="10" rx="1.5" fill="#F9EFD7"/>
    <rect x="27" y="21" width="3" height="10" rx="1.5" fill="#F9EFD7"/>
    <rect x="14" y="21" width="3" height="7" rx="1.5" fill="#F9EFD7" opacity="0.5"/>
    <rect x="23" y="21" width="3" height="7" rx="1.5" fill="#F9EFD7" opacity="0.5"/>
  </svg>
);

const IconBar = () => (
  <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
    <rect x="5" y="10" width="30" height="5" rx="2.5" fill="#F9EFD7"/>
    <rect x="5" y="15" width="4" height="18" rx="2" fill="#F9EFD7" opacity="0.7"/>
    <rect x="31" y="15" width="4" height="18" rx="2" fill="#F9EFD7" opacity="0.7"/>
    <circle cx="14" cy="22" r="3" fill="#F9EFD7" opacity="0.5"/>
    <circle cx="20" cy="22" r="3" fill="#F9EFD7" opacity="0.5"/>
    <circle cx="26" cy="22" r="3" fill="#F9EFD7" opacity="0.5"/>
  </svg>
);

const IconTakeaway = () => (
  <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
    <rect x="10" y="16" width="20" height="18" rx="3" fill="#F9EFD7" opacity="0.9"/>
    <path d="M15 16 Q15 10 20 10 Q25 10 25 16" stroke="#58735A" strokeWidth="2" fill="none" strokeLinecap="round"/>
    <rect x="15" y="21" width="10" height="1.5" rx="0.75" fill="#58735A" opacity="0.5"/>
    <rect x="15" y="25" width="7" height="1.5" rx="0.75" fill="#58735A" opacity="0.5"/>
  </svg>
);

const IconGeneric = () => (
  <svg width="28" height="28" viewBox="0 0 22 22" fill="none">
    <rect x="4" y="3" width="14" height="16" rx="2" fill="#F9EFD7" opacity="0.9"/>
    <rect x="7" y="7" width="8" height="1.5" rx="0.75" fill="#58735A"/>
    <rect x="7" y="10" width="6" height="1.5" rx="0.75" fill="#58735A"/>
    <rect x="7" y="13" width="7" height="1.5" rx="0.75" fill="#58735A"/>
  </svg>
);

const IconTableBg = () => (
  <svg width="90" height="90" viewBox="0 0 40 40" fill="none">
    <rect x="8" y="17" width="24" height="4" rx="2" fill="white"/>
    <rect x="10" y="21" width="3" height="10" rx="1.5" fill="white"/>
    <rect x="27" y="21" width="3" height="10" rx="1.5" fill="white"/>
    <rect x="14" y="21" width="3" height="7" rx="1.5" fill="white"/>
    <rect x="23" y="21" width="3" height="7" rx="1.5" fill="white"/>
  </svg>
);

const IconBarBg = () => (
  <svg width="90" height="90" viewBox="0 0 40 40" fill="none">
    <rect x="5" y="10" width="30" height="5" rx="2.5" fill="white"/>
    <rect x="5" y="15" width="4" height="18" rx="2" fill="white"/>
    <rect x="31" y="15" width="4" height="18" rx="2" fill="white"/>
    <circle cx="14" cy="22" r="3" fill="white"/>
    <circle cx="20" cy="22" r="3" fill="white"/>
    <circle cx="26" cy="22" r="3" fill="white"/>
  </svg>
);

const IconTakeawayBg = () => (
  <svg width="90" height="90" viewBox="0 0 40 40" fill="none">
    <rect x="10" y="16" width="20" height="18" rx="3" fill="white"/>
    <path d="M15 16 Q15 10 20 10 Q25 10 25 16" stroke="white" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
  </svg>
);

const IconGenericBg = () => (
  <svg width="90" height="90" viewBox="0 0 22 22" fill="none">
    <rect x="4" y="3" width="14" height="16" rx="2" fill="white"/>
  </svg>
);

const ORDER_CONFIG = {
  table: {
    bg:       '#3F1907',
    subColor: '#c4a882',
    timeColor:'#a08060',
    Icon:     IconTable,
    BgIcon:   IconTableBg
  },
  bar: {
    bg:       '#3F1907',
    subColor: '#c4a882',
    timeColor:'#a08060',
    Icon:     IconBar,
    BgIcon:   IconBarBg
  },
  takeaway: {
    bg:       '#58735A',
    subColor: '#c8dfc9',
    timeColor:'#a0c0a2',
    Icon:     IconTakeaway,
    BgIcon:   IconTakeawayBg
  },
  named: {
    bg:       '#3F1907',
    subColor: '#c4a882',
    timeColor:'#a08060',
    Icon:     IconTable,
    BgIcon:   IconTableBg
  },
  generic: {
    bg:       '#58735A',
    subColor: '#c8dfc9',
    timeColor:'#a0c0a2',
    Icon:     IconGeneric,
    BgIcon:   IconGenericBg
  }
};

const OrderCard = ({ order, onClick }) => {
  const type   = getOrderType(order.order_name);
  const config = ORDER_CONFIG[type];
  const { Icon, BgIcon } = config;

  const displayName = order.order_name || `Orden #${order.order_number}`;
  const time = order.created_at
    ? new Date(order.created_at).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })
    : '--:--';

  return (
    <div
      onClick={onClick}
      style={{
        background:   config.bg,
        borderRadius: '12px',
        padding:      '16px',
        cursor:       'pointer',
        position:     'relative',
        overflow:     'hidden'
      }}
    >
      <div style={{ position: 'absolute', right: '-10px', bottom: '-10px', opacity: 0.12 }}>
        <BgIcon />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <Icon />
      </div>

      <p style={{ margin: 0, fontSize: '17px', fontWeight: '500', color: '#F9EFD7', lineHeight: '1.2' }}>
        {displayName}
      </p>
      <p style={{ margin: '4px 0 0', fontSize: '12px', color: config.subColor }}>
        #{order.order_number} · ${Number(order.total || 0).toFixed(2)}
      </p>
      <p style={{ margin: '3px 0 0', fontSize: '11px', color: config.timeColor }}>
        {time}
      </p>
    </div>
  );
};

const OrdersList = ({ sesionActiva, setView, onSelectOrder }) => {
  const [orders, setOrders]   = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetchOrders();
  }, []);

 const fetchOrders = async () => {
  try {
    const res  = await fetch('/api/get_open_orders.php');
    const data = await res.json();
    // FIX: el PHP devuelve data.orders
    if (data.success && Array.isArray(data.orders)) {
      setOrders(data.orders);
    } else {
      setOrders([]);
    }
  } catch (error) {
    console.error("Error:", error);
    setOrders([]);
  } finally {
    setLoading(false);
  }
};

  const handleOpenOrder = (order) => {
    if (onSelectOrder) {
      onSelectOrder(order.id);
    } else {
      localStorage.setItem('currentOrderId', order.id);
      setView('pos');
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '40px', color: '#3F1907' }}>Cargando órdenes...</div>;
  }

  return (
    <div style={{ background: '#F9EFD7', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '500', color: '#3F1907' }}>
          Órdenes Abiertas
        </h2>
        {orders.length > 0 && (
          <span style={{ fontSize: '13px', color: '#58735A', fontWeight: '500' }}>
            {orders.length} activa{orders.length !== 1 ? 's' : ''}
          </span>
        )}
      </div>

      {orders.length === 0 ? (
        <p style={{ color: '#58735A', fontSize: '14px', textAlign: 'center', padding: '24px 0' }}>
          No hay órdenes abiertas
        </p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '12px' }}>
          {orders.map(order => (
            <OrderCard
              key={order.id}
              order={order}
              onClick={() => handleOpenOrder(order)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default OrdersList;